import styles from './DBadge.module.css';

export default function DBadge({ dday }) {
  if (dday === null || dday === undefined) return null;
  if (dday < 0)  return <span className={`${styles.badge} ${styles.closed}`}>마감</span>;
  if (dday === 0) return <span className={`${styles.badge} ${styles.dday}`}>D-DAY</span>;
  if (dday <= 3) return <span className={`${styles.badge} ${styles.urgent}`}>D-{dday}</span>;
  return <span className={styles.badge}>D-{dday}</span>;
}
